<div class="container">
  <ul
    class="account-nav d-flex flex-row align-items-center"
    [ngClass]="{ 'partner-mobile-nav': isPartner }"
    *autoScrollNavbar="'account-nav'"
  >
    <a
      class="nav-item account-item"
      [routerLink]="['/account']"
      [routerLinkActive]="'active'"
      [class.active]="isActive('/account')"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <!--Account Icon Switch-->
      <label>{{ 'account.nav.profile' | translate }}</label>
    </a>
    <a
      class="nav-item activity-item"
      [routerLink]="['/activity']"
      [routerLinkActive]="'active'"
      [class.active]="isActive('/activity')"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <!--Activity Icon Switch-->
      <label>{{ 'account.nav.activity' | translate }}</label>
    </a>
    <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.partners'">
      <ng-container *inProductCode="productCode.ShouldSeePartners">
        <a
          class="nav-item"
          [routerLink]="['/partners']"
          [routerLinkActive]="'active'"
          [class.active]="isActive('/partners')"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <label>{{ 'account.nav.partners' | translate }}</label>
        </a>
        <a
          class="nav-item"
          [routerLink]="['/pointsmanagement']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          [class.active]="isActive('/pointsmanagement')"
        >
          <label>{{ 'account.nav.pointsmanagement' | translate }}</label>
        </a>
      </ng-container>
    </ng-container>
  </ul>
</div>
